import React, { Children, useContext, useEffect } from "react";
import { AccordionContent } from "@radix-ui/react-accordion";
import PropTypes from "prop-types";
import cc from "classcat";
import { SidebarContext } from "./SidebarContext";
import { SidebarMenuItemContext } from "./SidebarMenuItemContext";
SidebarMenuItemChildren.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};
export default function SidebarMenuItemChildren(param) {
    var children = param.children, className = param.className;
    var _useContext = useContext(SidebarContext), expanded = _useContext.expanded, setExpanded = _useContext.setExpanded;
    var id = useContext(SidebarMenuItemContext).id;
    useEffect(function() {
        var childrenIdsArray = Children.toArray(children).map(function(child) {
            return child.props.id;
        });
        for(var i = 0; i < childrenIdsArray.length; i++){
            if (expanded.includes(childrenIdsArray[i]) && !expanded.includes(id)) {
                setExpanded(expanded.filter(function(item) {
                    return !childrenIdsArray.includes(item);
                }));
                break;
            }
        }
    }, [
        expanded
    ]);
    return /*#__PURE__*/ React.createElement(AccordionContent, {
        className: cc([
            "overflow-hidden transition-all duration-300 data-[state=closed]:animate-closeSidebarSubmenu data-[state=open]:animate-openSidebarSubmenu",
            className
        ])
    }, children);
}
